import background from "../../../images/destination/background-destination-desktop.jpg";
import NavBar from "../../navbar/MainNavBar";
import moon from "../../../images/destination/image-moon.webp";
import { Link } from "react-router-dom";

const DestinationDesk = () => {
  const myStyle = {
    backgroundImage: `url(${background})`,
    backgroundSize: "cover",
    minHeight: "100vh",
  };

  return (
    <div style={myStyle}>
      <NavBar />
      <p className="p-style" style={{ marginLeft: "2rem" }}>
        {" "}
        <strong className="strong">01</strong>PICK YOUR DESTINATION
      </p>
      <div
        style={{
          padding: "0 2rem",
          textAlign: "left",
          alignItems: "center",
          display: "flex",
          flexDirection: "row",
          paddingBottom: "3rem",
          justifyContent: "space-around",
          margin: "2rem auto 0",
          width: "80%",
        }}
      >
        <img
          src={moon}
          style={{ width: "25rem", height: "25rem", margin: "5rem" }}
        />
        <div style={{ position: "relative" }}>
          <div style={{ marginBottom: "2rem" }}>
            <Link
              className="destinaion-links p-style"
              to="/destination/"
              style={{ borderBottom: "2px solid white", marginLeft: 0 }}
            >
              MOON
            </Link>
            <Link className="destinaion-links p-style" to="/destination/mars">
              MARS
            </Link>
            <Link className="destinaion-links p-style" to="/destination/europa">
              EUROPA
            </Link>
            <Link className="destinaion-links p-style" to="/destination/titan">
              TITAN
            </Link>
          </div>
          <h1 style={{ margin: 0, textTransform: "uppercase" }}>MOON</h1>
          <p>
            See our planet as you’ve never seen it before. A perfect relaxing
            trip away to help regain perspective and come back refreshed. While
            you’re there, take in some history by visiting the Luna 2 and Apollo
            11 landing sites.
          </p>
          <span style={{ width: "90%", position: "absolute" }}></span>
          <div className="dis-box" style={{ margin: "4rem 0" }}>
            <div style={{ margin: " 0 4rem 0 0 " }}>
              {" "}
              <p className="p-style" style={{ margin: 0 }}>
                AVG. DISTANCE
              </p>
              <h3 style={{ textTransform: "uppercase" }}>384,400 km</h3>
            </div>
            <div>
              <p className="p-style" style={{ textTransform: "uppercase" }}>
                EST. TRAVEL TIME
              </p>
              <h3 style={{ textTransform: "uppercase" }}>3 days</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DestinationDesk;
